<template>
  <div>    
	<el-tabs type="border-card"> 
		<el-tab-pane label="余额明细">	
    <el-form
      ref="form"
      :model="so"
      label-width="120px"
      style="background: #FFFFFF; padding: 20px 20px 20px 80px;"
    >
     
     <div class="" style="display: flex;">
		 <el-form-item label="会员信息" style="width: 30%;">
		   <el-input v-model="so.guanjianci" placeholder="可搜索姓名/昵称/手机号"></el-input>
		 </el-form-item>
		 <el-form-item label="会员ID" style="width: 30%;">
		   <el-input v-model="so.hyid" placeholder="可搜索会员ID"></el-input>
		 </el-form-item>
		 <el-form-item label="核销员ID" style="width: 30%;">
		   <el-input v-model="so.hexiaoyuan" placeholder="可搜索核销员ID"></el-input>
		 </el-form-item>
	 </div>
	  <div class="" style="display: flex;">
		  <el-form-item label="发布时间">
		    <el-date-picker
		   		v-model="so.shijian"
		      type="daterange"
		      range-separator="至"
		      start-placeholder="开始日期" 
		      end-placeholder="结束日期"
		    ></el-date-picker>
		  </el-form-item>
     <el-form-item label="订单号">
       <el-input v-model="so.dingdanhao" placeholder="订单号"></el-input>
     </el-form-item>
     <el-form-item label="说明">
       <el-input v-model="so.shuoming" placeholder="说明"></el-input>
     </el-form-item>
	 <el-form-item label="店名">
	   <el-input v-model="so.dianming" placeholder="店名"></el-input>
	 </el-form-item>
	<!-- <div class="" style="display: flex;">
		 <el-form-item label="平台">
				 <el-select v-model="so.laiyuan" placeholder="请选择" style="width:100%">
					 <el-option label="不限" value=""></el-option>
					<el-option label="左福右利平台" value="1"></el-option>
					<el-option label="工惠优选平台" value="2"></el-option>
					<el-option label="数福平台" value="3"></el-option>
				 </el-select>
		 </el-form-item>
	 </div> -->
	 </div>
	 <el-form-item label="线下扫码枪">
	 		<el-select v-model="so.smq" placeholder="请选择">
	 			<el-option label="不限" value=""></el-option>
	 			<el-option label="扫码枪" value="1"></el-option>
	 		</el-select>
	  </el-form-item>
     <!-- <el-form-item label="类型">
			<el-select v-model="so.leixing" placeholder="请选择">
				<el-option label="不限" value=""></el-option>
				<el-option v-for="(l,k) in shu.leixing" :label="l" :value="k"></el-option>
			</el-select>
      </el-form-item> -->
    <!--  <el-form-item label="状态">
        <el-select v-model="so.zhuangtai" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label>
        <el-button type="primary" size="small"  @click="CSH">搜索</el-button>
		<el-button type="primary" size="small" @click="Daochu" >导出Excel</el-button>
      </el-form-item>
	  
	 <div class="" style="display: flex;" >
	  
	  <el-form-item label="卡密" style="width: 30%;">
	    <el-input v-model="so.hexiaokami" placeholder="核销卡密"></el-input>
	  </el-form-item>
	  <el-form-item label="核销金额" style="width: 30%;">
	    <el-input v-model="so.hexiaojine" placeholder="核销金额"></el-input>
	  </el-form-item>
	   <el-button type="primary" size="small" style='height:40px;margin-left:10px'  @click="Hexiao">核销</el-button>
	   
	   </div> 
	   
	   
    </el-form>
	<div>
		核销总额：{{shu.weiyongshu}}
	</div>
	
    <el-divider></el-divider>
    <el-table :data="shu.lie" style="width: 100%">
      <el-table-column prop="shijian" label="时间"  width="180" ></el-table-column>
      <el-table-column prop="shming" label="店名"   width="220" ></el-table-column> 
    <!--  <el-table-column prop="huiyuan_id" label="会员ID"></el-table-column>
	    <el-table-column prop="nicheng" label="会员昵称"></el-table-column> -->
		
		<el-table-column prop="zhanghao" label="会员ID/昵称/手机" width="250" >
			<template slot-scope="shu">
				<div>{{shu.row.huiyuan_id}}</div>
				<div>{{shu.row.nicheng}}</div>
				<div>{{shu.row.zhanghao}}</div>
		<!-- 		<span class="eltag el-tag el-tag--dark" :class="(shu.row.xinpin==1)?'':'el-tag--info'" @click="Biaoqian(shu.row,'xinpin',1)">新品</span>
				<span class="eltag el-tag el-tag--dark" :class="(shu.row.tuijian==1)?'':'el-tag--info'" @click="Biaoqian(shu.row,'tuijian',1)">推荐</span>	 -->					
			</template>
		</el-table-column>
		
		<el-table-column prop="zhanghao" label="核销员ID/昵称" width="280" >
			<template slot-scope="shu">
				<div v-if="shu.row.hexiaoyuan>0">{{shu.row.hexiaoyuan}}</div>
				<div  v-if="shu.row.hexiaoyuan">{{shu.row.hexiaoyuannicheng}}</div>
			</template>
		</el-table-column>
		
		<el-table-column prop="zhifuqudao" label="支付渠道"  width="80" >
			<template slot-scope="shu">
				<div v-if="shu.row.zhifuqudao=='weixin' || shu.row.zhifuqudao=='xiaochengxu'">微信支付</div>
				<el-tag effect="dark" v-else-if="shu.row.zhifuqudao=='fulika'">福利卡</el-tag>
			</template>
		</el-table-column>
      <el-table-column prop="yuanzhi" label="额度"  width="80" ></el-table-column>
	   <el-table-column prop="dingdanhao" label="订单号"  width="270" ></el-table-column>
      <el-table-column prop="shuoming" label="说明"></el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev,pager,next,jumper"
      :total="shu.zongshu"
      :page-size="so.jitiao"
      :current-page.sync="so.ye"
      @current-change="CSH"
      style="margin-top: 30px;"
    />
		</el-tab-pane>
	</el-tabs>
	
  </div>
</template>

<script>
var that;
export default {
  data() {
    return {
     
      shu: {
        lie: [],
        zongshu: 0,
		leixing:[],
		weiyongshu: 0,
		jifenshu:0,
		hexiaoyuannicheng:'',
		hexiaoyuan:''
      },
      so: {zhuangtai:'',ye: 1,jitiao: 20,},
      options: [{ label: "不限", value: "" },{ label: "待到账", value: "0" },{ label: "已到账", value: "1" }],
	}
  },
  created() {
    that = this;
    this.CSH();
  },
  methods: {
	Hexiao(){
		 this.$post("m=limitao&k=hexiaomingxi&c=hexiao", this.so, (s)=> {
			 
		 })
	},  
	  
	  
	  
    CSH() {     
      that.$post("k=huiyuan&c=Fulika", that.so, function(s) {
        that.shu = s.shu;
		that.shu.zongshu =parseInt(s.shu.zongshu);
      });
    },
	Daochu(){
		this.$post('k=huiyuan&c=Daochufulika', that.so, function(s) {
			if(s.shi==1){
				window.open(that.$url+'&k=denglu&c=daochu&wenjianming='+s.shu);  
			}else{
				that.$xiaoxi(s.shu);			
			}
		});
	},
  }
};
</script>

<style>
.biaoti {
  display: block;
  width: 100%;
  text-indent: 10px;
  margin-bottom: 16px;
  font-size: 20px;
  color: #788188;
}
</style>
